export default {
  // Sections générales du profil
  'about': 'À propos',
  'services': 'Services',
  'gallery': 'Galerie',
  'reviews': 'Avis',
  'contact': 'Contact',
  'rates': 'Tarifs',
  'rate_30min': '30 min',
  'rate_1hour': '1 heure',
  'rate_2hours': '2 heures',
  'rate_overnight': 'Nuit complète',
  'rate_weekend': 'Week-end',
  'rates_note': 'Les prix peuvent varier. Contactez pour plus de détails.',
  'languages': 'Langues',
  'attributes': 'Attributs',
  'availability': 'Disponibilité',
  'send_message': 'Envoyer un message',
  'save': 'Sauvegarder',
  'saved': 'Sauvegardé',
  'subscribe': 'S\'abonner',
  'tour_dates': 'Dates de tournée',
  'more_about_me': 'Plus sur moi',
  'physical_attributes': 'Attributs physiques',
  'personal_info': 'Informations personnelles',
  'subscription_required': 'Abonnement requis',
  'upgrade_subscription': 'Améliorer l\'abonnement',
  'rates_only_visible': 'Les tarifs sont visibles uniquement aux abonnés',
  'services_available': 'Services disponibles',
  'reviews_only_visible': 'Les avis sont visibles uniquement aux membres Regular et VIP',
  'subscription_unlock': 'Abonnez-vous pour débloquer son contenu exclusif',
  'view_profile': 'Voir le profil',
  'message': 'Message',
  'verified': 'Vérifié',
  'online': 'En ligne',
  'touring': 'En tournée',
  'favorite': 'Ajouter aux favoris',
  'unfavorite': 'Retirer des favoris',
  'tabs_about': 'À propos',
  'tabs_services': 'Services',
  'tabs_rates': 'Tarifs',
  'tabs_contact': 'Contact',
  'various_durations': 'Durées variables',
  'no_services': 'Aucun service listé',
  'no_rates': 'Aucun tarif listé',
  'back': 'Retour',
  'last_online': 'Dernière connexion',
  'registration_date': 'Date d\'inscription',
  'total_views': 'Vues totales',
  'personal_information': 'Informations personnelles',
  'sexual_details': 'Détails sexuels',
  'available_services': 'Services disponibles',
  'working_hours': 'Horaires de travail',
  'about_me': 'À propos de moi',
  'call': 'Appeler',
  'booking': 'Réservation',
  'contact_availability': 'Contact et disponibilité',
  'years': 'ans',
  'no_phone_number': 'Pas de numéro de téléphone',
  'contact_through_message': 'Veuillez contacter par message',
  'added_to_favorites': 'Ajouté aux favoris',
  'removed_from_favorites': 'Retiré des favoris',
  'profile_added_to_favorites': '{{name}} a été ajouté à vos favoris',
  'profile_removed_from_favorites': '{{name}} a été retiré de vos favoris',
  'generating_image': 'Génération de l\'image de profil...',
  
  // Réservations
  'select_date': 'Sélectionnez une date',
  'select_time': 'Sélectionnez une heure',
  'confirm_booking': 'Confirmer la réservation',
  'booking_confirmed': 'Réservation confirmée',
  'booking_error': 'Erreur de réservation',
  'select_date_time': 'Veuillez sélectionner une date et une heure',
  'booking_description': 'Réservez votre rendez-vous avec cette escort',
  'booking_with': 'Réservation avec',
  'booking_for': 'pour le',
  'booking_at': 'à',
  'no_availability': 'Pas de disponibilité dans les prochaines 24 heures',
  'check_availability': 'Vérifier la disponibilité',
  
  // Contenu privé
  'public_view': 'Profil',
  'subscriber_view': 'Accès Privé',
  'private_media': 'Médias Privés',
  'private_secrets': 'Secrets Privés',
  'premium_services': 'Services Premium',
  'premium_services_offered': 'Services premium proposés',
  'unlock_private_content': 'Débloquer le Contenu Privé',
  'private_content_description': 'Abonnez-vous pour accéder aux photos exclusives, vidéos et services spéciaux.',
  'view_private_content': 'Voir le Contenu Privé',
  'private_content_locked': 'Contenu Privé Verrouillé',
  'private_content_subscription_needed': 'Abonnez-vous pour débloquer le contenu exclusif et les services de cette escort',
  'view_all_services': 'Voir Tous les Services',
  'teaser_upgrade_message': 'Vous avez un accès Teaser. Passez à Regular pour voir tout le contenu',
  'upgrade_now': 'Améliorer Maintenant',
  'premium_content': 'Contenu Premium',
  'exclusive_content': 'Contenu exclusif',
  'exclusive_content_locked': 'Contenu exclusif verrouillé',
  'private_media_subscription_needed': 'Abonnez-vous à {{name}} pour accéder à son contenu exclusif',
  
  // Services et tarifs
  'time': 'Durée',
  'incall': 'Chez moi',
  'outcall': 'Déplacement',
  'included': 'Inclus',
  'extra': 'Supplément',
  'show_less': 'Voir moins',
  'services_description': 'Services inclus dans les tarifs standards ou disponibles moyennant un supplément.',
  'premium_services_description': 'Services numériques premium qui peuvent être achetés séparément sans réserver de rendez-vous.',
  'rates_incall': 'Rencontres (Incall)',
  'rates_outcall': 'Déplacements (Outcall)',
  'rates_special': 'Spécial',
  'no_slots_available': 'Aucun créneau disponible',
  'select_rate': 'Sélectionner un tarif',
  'select_category': 'Type de rencontre',
  
  // Sections d'abonnement et accès
  'premium_access': 'Accès Premium',
  'access_exclusive_content': 'Accédez au contenu exclusif de {{name}}',
  'access_exclusive_content_for': 'Accédez à tout le contenu exclusif de {name}',
  'price_per_month': '{price}€ / mois',
  'private_photos_videos': 'Photos et vidéos exclusives',
  'priority_messages': 'Messages prioritaires',
  'secure_payment_cancel_anytime': 'Paiement sécurisé. Annulez à tout moment.',
  'more_services': '+ {count} autres services',
  'service_placeholder_1': 'Service exclusif A',
  'service_placeholder_2': 'Vidéo personnalisée',
  'service_placeholder_3': 'Accès groupe privé',
  
  // Traductions pour le contenu privé et médias
  'per_month': 'par mois',
  'no_private_photos_yet': 'Pas encore de photos privées',
  'no_premium_services_yet': 'Pas encore de services premium',
  'private_content_alt': 'Photo privée',
  'no_private_photos_available': 'Aucune photo privée disponible',
  'no_secrets_available': 'Aucun secret disponible',
  'no_premium_services_available': 'Aucun service premium disponible',
  'other_services': 'autres services',
  
  // Traductions pour les onglets du profil
  'profile_gender': 'Genre',
  'profile_age': 'Âge',
  'profile_nationality': 'Nationalité',
  'profile_ethnicity': 'Ethnicité',
  'profile_eye_color': 'Couleur des yeux',
  'profile_hair_color': 'Couleur des cheveux',
  'profile_height': 'Taille',
  'profile_unit_cm': 'cm',
  'profile_weight': 'Poids',
  'profile_unit_kg': 'kg',
  'profile_measurements': 'Mensurations',
  'profile_cup_size': 'Taille de bonnet',
  'profile_intimate_area': 'Zone intime',
  'profile_smoking': 'Tabac',
  'profile_drinking': 'Alcool',
  'profile_sexual_information': 'Informations sexuelles',
  'profile_orientation': 'Orientation',
  'profile_interested_in': 'Intéressé(e) par',
  'profile_preferences': 'Préférences',
  'profile_value_couples': 'Couples',
  'profile_value_singles': 'Célibataires',
  'profile_experience': 'Expérience',
  'profile_value_intermediate': 'Intermédiaire',
  'profile_kinks': 'Fantasmes',
  'profile_value_roleplay_lightbdsm': 'Jeux de rôle, BDSM léger',
  'profile_limits': 'Limites',
  'profile_value_extreme_illegal': 'Douleur extrême, activités illégales',
  'profile_premium_prompt': 'Abonnez-vous pour découvrir ses petits secrets',
  'profile_contact_information': 'Informations de contact',
  'profile_phone': 'Téléphone',
  'profile_alternative_phone': 'Téléphone alternatif',
  'profile_contact_via': 'Contacter via',
  'profile_available': 'Disponible',
  'profile_hours': 'Heures',
  'profile_registered_date_prefix': 'Inscrit(e) le',
  'profile_today': 'Aujourd\'hui',
  'profile_whatsapp': 'WhatsApp',
  'profile_value_available': 'Disponible',
  'profile_city': 'Ville',
  'profile_contact_instructions': 'Veuillez indiquer par SMS votre âge, origine et durée souhaitée.',
  'profile_call_button': 'Appeler',
  'profile_day_monday': 'Lundi',
  'profile_day_tuesday': 'Mardi',
  'profile_day_wednesday': 'Mercredi',
  'profile_day_thursday': 'Jeudi',
  'profile_day_friday': 'Vendredi',
  'profile_day_saturday': 'Samedi',
  'profile_day_sunday': 'Dimanche',
  
  // Accès privé et contenu
  'private_access': 'Accès Privé',
  'profile_about_me': 'À propos de moi',
  'profile_about_personal_information': 'Informations personnelles',
  'profile_about_sexual_details': 'Détails sexuels',
  'profile_about_services': 'Services disponibles',
  'profile_about_rates': 'Tarifs',
  'profile_about_working_hours': 'Horaires de travail',
  'profile_private_content_title': 'Contenu Privé',
  'profile_private_content_description': 'Accédez à du contenu exclusif et des services spéciaux',
  'profile_private_content_subscription_needed': 'Un abonnement est nécessaire pour accéder à ce contenu',
  'profile_private_content_photos_videos': 'Photos et vidéos exclusives',
  'profile_private_content_secrets': 'Ses petits secrets',
  'profile_private_content_services': 'Services premium proposés',
  'profile_private_content_messages': 'Messages prioritaires',
  'profile_private_content_secure_payment': 'Paiement sécurisé',
  'profile_private_content_cancel_anytime': 'Annulez à tout moment',
  'profile_private_content_buy': 'Acheter',
  'profile_private_content_monthly': '/mois',
  'profile_private_content_upgrade_to_regular': 'Passez à Regular pour un accès complet',
  'profile_default_bio': 'Accompagnatrice élégante et sophistiquée passionnée par l\'art et la gastronomie.',
  'profile_verified': 'Vérifié',
  
  // Feed et médias privés (nouvelles fonctionnalités)
  'posts': 'Publications',
  'feed': 'Feed',
  'media': 'Médias',
  'no_posts_yet': 'Aucune publication pour le moment',
  'no_posts_subscribed': "{{name}} n'a pas encore partagé de publications",
  'no_posts_not_subscribed': 'Abonnez-vous pour voir les publications',
  'subscribe_to_see_posts': 'S\'abonner pour voir les publications',
  'subscribe_to_see_all': 'S\'abonner pour tout voir',
  'pay_per_view': 'Pay-per-view',
  'one_time_purchase': 'Achat unique',
  'purchase_now': 'Acheter maintenant',
  'unlock': 'Débloquer',
  'purchased': 'Acheté',
  'pay_per_view_description': 'Achetez ce contenu pour y accéder de façon permanente',
  'unlock_premium_content': 'Débloquer ce contenu premium',
  'unlock_forever': 'Accès permanent',
  'high_quality': 'Haute qualité',
  'view_anytime': 'Visionnez quand vous voulez',
  'price': 'Prix',
  'processing': 'Traitement en cours...',
  'purchase_successful': 'Achat réussi !',
  'enjoy_exclusive_content': 'Profitez de ce contenu exclusif',
  'purchase_error': 'Erreur lors de l\'achat',
  'no_private_media_yet': 'Aucun média privé pour le moment',
  'no_pay_per_view_media': 'Aucun média pay-per-view disponible',
  'check_back_later': 'Revenez plus tard pour voir les nouveautés',
  
  // Abonnements
  'subscribe_to_content': 'S\'abonner au contenu',
  'unlock_exclusive_content': 'Débloquer le contenu exclusif de {{name}}',
  'fan_subscription': 'Abonnement fan',
  'monthly_subscription': 'Abonnement mensuel',
  'full_media_access': 'Accès complet aux médias privés',
  'exclusive_posts': 'Publications exclusives',
  'direct_messaging': 'Messages directs prioritaires',
  'cancel_anytime': 'Annulez à tout moment',
  'subscribe_now': 'S\'abonner maintenant',
  'subscription_success': 'Abonnement réussi !',
  'subscription_success_description': 'Vous êtes maintenant abonné(e) à {{name}}',
  
  // Feed et commentaires
  'like': 'J\'aime',
  'comment': 'Commenter',
  'share': 'Partager',
  'comments': 'commentaires',
  'no_comments_yet': 'Aucun commentaire pour le moment',
  'write_a_comment': 'Écrivez un commentaire...',
  'user': 'Utilisateur',
  'reply': 'Répondre',
  'load_more_posts': 'Charger plus de publications',
  'votes': 'votes',
  'poll': 'Sondage',
  'subscribers_only': 'Abonnés uniquement'
};
